// extracted by mini-css-extract-plugin
export default {"image":"jY-z","loaded":"kY-z"};